import React from 'react';
import '../styles/FlexGrid.css';
import MainBox from './gridcomponents/MainBox';
import SecondaryBox1 from './gridcomponents/SecondaryBox1';
import SecondaryBox2 from './gridcomponents/SecondaryBox2';
import SecondaryBox3 from './gridcomponents/SecondaryBox3';
import SecondaryBox4 from './gridcomponents/SecondaryBox4';
import law from '../assets/law.jpg';
import { Link } from 'react-router-dom';

const translations = {
  en: {
    legalFramework: "Legal Framework",
    permitsRegulations: "Permits & Regulations",
    altText: "Legal documentation illustration"
  },
  es: {
    legalFramework: "Marco Legal",
    permitsRegulations: "Permisos y Regulaciones",
    altText: "Ilustración de documentación legal"
  }
};

export default function FlexGrid(props) {
  return (
    <div className="FlexGridcontainer">
      <div className="upper-section">
        <div className="main-square">
          <MainBox 
            MainBoxImage={props.MainBoxImage}
            MainBoxSubtitle={props.MainBoxSubtitle}
            language={props.language}
          />         
        </div>
        <div className="side-container">
          <div className="side-square">
            <SecondaryBox1
              SecondaryBoxTitle1={props.SecondaryBoxTitle1}
              SecondaryBoxSubtitle1={props.SecondaryBoxSubtitle1}
              SecondaryBoxImage1={props.SecondaryBoxImage1}
            />
          </div>
          <div className="side-square">
            <SecondaryBox2
              SecondaryBoxTitle2={props.SecondaryBoxTitle2}
              SecondaryBoxSubtitle2={props.SecondaryBoxSubtitle2}
              SecondaryBoxImage2={props.SecondaryBoxImage2}
            />
          </div>
          <div className="side-square">
            <SecondaryBox3
              SecondaryBoxTitle3={props.SecondaryBoxTitle3}
              SecondaryBoxSubtitle3={props.SecondaryBoxSubtitle3}
              SecondaryBoxImage3={props.SecondaryBoxImage3}
            />
          </div>
          <div className="side-square">
            <SecondaryBox4
              SecondaryBoxTitle4={props.SecondaryBoxTitle4}
              SecondaryBoxSubtitle4={props.SecondaryBoxSubtitle4}
              SecondaryBoxImage4={props.SecondaryBoxImage4}
            />
          </div>
        </div>
      </div>

      <Link to="/legal" style={{ textDecoration: 'none' }}>
        <div className="lower-section">
          <h1>{translations[props.language].legalFramework}</h1>
          <h2>{translations[props.language].permitsRegulations}</h2>
          <div className="lower-section-container">
            <img 
              src={law} 
              alt={translations[props.language].altText} 
            />
          </div>
        </div>
      </Link>
    </div>
  );
}